import { Box, Typography, IconButton } from '@mui/material';
import {
  AddBoxRounded,
  CheckCircleRounded,
  Close as CloseIcon,
  IosShareRounded,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import videoPWA from '../../../assets/videos/pwaiOS.mp4';

const Step = ({ number, title, icon, children }) => (
  <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
    <Box
      sx={{
        borderRadius: '8px',
        backgroundColor: 'primary.main',
        color: 'white',
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: '24px',
        fontSize: '1.178rem',
        fontWeight: 'bold',
      }}
    >
      {number}
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px' }}
        >
          {icon}
        </Box>
        <Typography variant='button' sx={{ lineHeight: 1.2, fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  </Box>
);

export const ManualInstalacionIos = () => {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Box sx={{ position: 'relative', pt: 4 }}>
      {/* Botón de cerrar estilo modal */}
      <IconButton
        onClick={handleGoBack}
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
        aria-label='cerrar'
      >
        <CloseIcon />
      </IconButton>

      <Typography variant='h4' component={'h1'} gutterBottom>
        Instalar aplicación
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          height: '200px',
          background: '#c0c0c0',
          borderRadius: '24px',
          margin: '32px 0',
          padding: '0',
        }}
      >
        <video
          loading='lazy'
          autoPlay
          loop
          muted
          style={{ width: '100%', maxWidth: '400px', borderRadius: '16px' }}
        >
          <source src={videoPWA} type='video/mp4' />
        </video>
      </Box>

      <Typography variant='h5' component={'h2'} gutterBottom>
        Cómo instalar en tu dispositivo Apple
      </Typography>

      <Typography variant='body1' gutterBottom mb={4}>
        Sigue estos sencillos pasos para tener Mi OSER siempre a mano en tu pantalla de inicio.
      </Typography>

      <Step number={1} icon={<IosShareRounded />} title='Acción'>
        <Typography variant='body1'>
          Toca el botón <strong>Compartir</strong> del navegador de tu dispositivo.
        </Typography>
      </Step>
      <Step number={2} icon={<AddBoxRounded />} title='Menú'>
        <Typography variant='body1'>
          Desliza hacia abajo y selecciona <strong>Agregar a inicio</strong>.
        </Typography>
      </Step>
      <Step number={3} icon={<CheckCircleRounded />} title='Finalizar'>
        <Typography variant='body1'>
          Confirmar tocando <strong>Agregar</strong> en la esquina superior.
        </Typography>
      </Step>
    </Box>
  );
};
